var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "loading-screen"
  }, [_c('Starfield'), _vm._l(_vm.lineCount, function (n) {
    return _c('div', {
      key: 'line-' + n,
      class: ['lineG', "line-".concat(n)]
    });
  }), _vm._l(_vm.boxCount, function (n) {
    return _c('div', {
      key: 'box-' + n,
      class: ['boxG', "box-".concat(n)]
    });
  }), _c('div', {
    staticClass: "box-line-out"
  }, [_c('div', {
    staticClass: "box-line-in"
  }, [_c('div', {
    attrs: {
      "id": "svg-container"
    }
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "width": "800px",
      "height": "800px",
      "viewBox": "0 0 800 800",
      "xml:space": "preserve"
    }
  }, [_c('g', {
    attrs: {
      "id": "circle"
    }
  }, [_c('circle', {
    staticClass: "circle",
    attrs: {
      "fill": "transparent",
      "stroke": "#0582f7",
      "stroke-width": "1",
      "stroke-miterlimit": "10",
      "cx": "400",
      "cy": "400",
      "r": "300"
    }
  })]), _c('g', {
    attrs: {
      "id": "quaters-circles"
    }
  }, [_c('path', {
    staticClass: "quater",
    attrs: {
      "fill": "none",
      "stroke": "#0582f7",
      "stroke-width": "3",
      "stroke-miterlimit": "10",
      "d": "M100,400c0-165.82,134.18-300,300-300"
    }
  }), _c('path', {
    staticClass: "quater",
    attrs: {
      "fill": "none",
      "stroke": "#0582f7",
      "stroke-width": "3",
      "stroke-miterlimit": "10",
      "d": "M700,400c0,165.82-134.18,300-300,300"
    }
  })])])]), _c('div', {
    staticClass: "logo-main"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("@/assets/SituationRoom_scss/src/logo_svg/full.svg")
    }
  }), _c('div', {
    staticClass: "text-group"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('h3', {
    ref: "scrambleText",
    staticClass: "scramble-text"
  }, [_c('span', {
    attrs: {
      "data-text": "Acmepointes"
    }
  }, [_vm._v("Acmepointes")]), _c('br'), _c('span', {
    attrs: {
      "data-text": "Dashboard"
    }
  }, [_vm._v("Dashboard")])])]), _vm._m(0)])])])])], 2);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "loading-text"
  }, [_vm._v("0%")]), _c('div', {
    staticClass: "loadBoxG"
  }, [_c('div', {
    staticClass: "loadBox-1"
  })])]);
}];
export { render, staticRenderFns };